import { generateColumnsDefaultConfiguration } from "../../../../../components/dataGrid/columnHelpers";

export function useTabProfesionalViewEquipoColumns() {
  const initialColumns = [
    {
      flex: 4,
      field: "tipoProfesional",
      headerName: "Tipo Profesional",
    },
    {
        field: 'frecuencia',
        headerName: 'Frecuencia',
        flex: 4,
    },
    {
        field: 'profesional',
        headerName: 'Profesional',
        flex: 2,
    }
  ];

  const columns = generateColumnsDefaultConfiguration(initialColumns, true);

  return columns;
}
